export default "__VITE_ASSET__BHqdcQzJ__"